import { styled, Typography } from '@mui/material';

export const VerticalTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  writingMode: 'vertical-rl',
  textOrientation: 'sideways',
  transform: 'rotate(180deg)',
}));
